export const userRoleValidationRules = (values) => {
  const errors = {};

  if (!values.name) errors.name = "Role name is required";
  if (values.name && values.name.length < 3) errors.name = "Name must be at least 3 characters";

  return errors;
};

export const userValidationRules = (values, isUpdate) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const pinCodeRegex = /^\d{5,10}$/;

  if (!values.username) errors.username = "Username is required";
  else if (values.username.length < 5) errors.username = "Username must be at least 5 characters";
  if (!values.firstName) errors.firstName = "First name is required";
  else if (values.firstName.length < 3) errors.firstName = "First name must be at least 3 characters";
  if (!values.lastName) errors.lastName = "Last name is required";
  else if (values.lastName.length < 1) errors.lastName = "Last name must be at least 1 characters";
  if (!isUpdate && !values.password) errors.password = "Password is required";
  else if (!isUpdate && values.password.length < 8) errors.password = "Password must be at least 8 characters";
  if (!values.primaryPhone) errors.primaryPhone = "Mobile number is required";
  else if (!phoneRegex.test(values.primaryPhone)) errors.primaryPhone = "Enter valid number (with country code)";
  if (!values.primaryEmail) errors.primaryEmail = "Email is required";
  else if (!emailRegex.test(values.primaryEmail)) errors.primaryEmail = "Enter a valid email";
  if (!values.roleId) errors.roleId = "Please select a role";
  if (values.primaryAddress?.pinCode && !pinCodeRegex.test(values.primaryAddress?.pinCode))
    errors.primaryAddress = { pinCode: "Enter valid pin code" };

  return errors;
};

export const resetPasswordValidation = (values) => {
  const errors = {};

  if (!values.password) errors.password = "Password is required";
  else if (values.password.length < 8) errors.password = "Password must be at least 8 characters";
  if (!values.confirmPassword) errors.confirmPassword = "Please confirm your password";
  if (values.password && values.confirmPassword && values.password !== values.confirmPassword)
    errors.confirmPassword = "Passwords do not match";

  return errors;
};
